import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import BackIcon from '@mui/icons-material/ChevronLeft';
import Button from 'components/Button';
import Spin from 'components/Spin';
import Wrapper from 'components/PageWrapper';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import ScriptInstructions from '../components/connect-widget/ScriptInstructions';
import LinkSetup from '../components/connect-widget/LinkSetup';
import {
  getWebsiteLinks,
  saveWebsiteLink,
  deleteWebsiteLink,
} from 'services/connect-card.service';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 0,
    overflow: 'hidden',
  },
  aside: {
    width: 340,
  },
  rightPanel: {},
}));

const steps = ['Link Your Website', 'Verify'];

const ConnectWebsiteSetup = ({ history }) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const account = useSelector((s) => s.settings.account);
  const [links, setLinks] = useState([]);

  const data = {};

  useEffect(() => {
    getWebsiteLinks({ account_hash: account.hash }).then(setLinks);
  }, []);

  const handleStep = (step) => () => {
    if (activeStep === 1) {
      history.goBack();
    } else {
      setActiveStep(step);
    }
  };

  const onInputChange = (e) => {};

  return (
    <Wrapper
      title={
        <>
          <Breadcrumbs>
            <MuiLink
              to="/connect/widgets"
              component={Link}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <BackIcon sx={{ mr: 0.5 }} color="disabled" /> Connect Widgets
            </MuiLink>
            <Typography>Link Website </Typography>
          </Breadcrumbs>
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item>
          <Box className={classes.aside}>
            <Paper sx={{ mb: 2 }}>
              <Box py={2} px={1}>
                <Stepper nonLinear activeStep={activeStep}>
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton color="inherit" onClick={handleStep(index)}>
                        {activeStep === index ? label : null}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </Paper>
            <Button fullWidth onClick={handleStep(1)}>
              {activeStep === 0 ? 'Next' : 'Done'}
            </Button>
          </Box>
        </Grid>
        <Grid item flex={1}>
          <Box className={classes.rightPanel}>
            {activeStep === 0 && (
              <ScriptInstructions hash={account.hash} onNext={handleStep(1)} />
            )}
            {activeStep === 1 && (
              <LinkSetup data={data} onInputChange={onInputChange} />
            )}
          </Box>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ConnectWebsiteSetup;
